module.exports = __webpack_public_path__ + "static/FarAwayBottle-d57fcfcee1f5e4040c73f94166f7a6a8.jpg";